import { render, staticRenderFns } from "./searchVtwd.vue?vue&type=template&id=0d3d91f8&scoped=true"
import script from "./searchVtwd.vue?vue&type=script&lang=js"
export * from "./searchVtwd.vue?vue&type=script&lang=js"
import style0 from "./searchVtwd.vue?vue&type=style&index=0&id=0d3d91f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3d91f8",
  null
  
)

export default component.exports